import { getDateAndTime, getLatestIteration } from "../../../lib/utils";

export const deletionIssues = ['All test executions & iterations', 'All test case associations for the test cycle', 'Comments and attachments', 'Any other related data'];

export const defaultFilters = {
  purpose: 'All',
  status: 'All',
  type: 'All',
  owner: [],
};

export const formatData = (testcycles) => {
  return testcycles?.map((testcycle) => {
    const statusCounts = {};
    let totalExecutions = 0;
    const statuses = [];
    const latestIteration = getLatestIteration(testcycle?.iteration_details);
    const latestIterationExecutions = [];
    const testExecutions = []
    const allTestCaseIds = new Set();
    const executedTestCaseIds = new Set();

    testcycle.associations.forEach((testCaseAssociation) => {
      const testCaseId = testCaseAssociation?.testcase?.id;  
      if (testCaseId) {
        allTestCaseIds.add(testCaseId);
      }
      testCaseAssociation?.test_case_executions?.forEach((execution) => {
        if (execution && latestIteration?.id === execution?.iteration) {
          latestIterationExecutions.push(execution);
        }
        testExecutions.push(execution);
        totalExecutions++;
        const statusName = execution?.status_details?.name;
        const statusColor = execution?.status_details?.color;
        if (testcycle.status.name === 'Completed' || execution.is_editable) {
          statusCounts[statusName] = statusCounts[statusName] || {
            count: 0,
            color: statusColor,
            name: statusName,
          };
          statusCounts[statusName].count++;
        }
        statuses.push(statusName);
        if (testCaseId) {
          executedTestCaseIds.add(testCaseId);
        }
      });
    });

    const testCasesWithNoExecutions = allTestCaseIds.size - executedTestCaseIds.size;
    const latestExecution = testExecutions?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))[0] || null;

    return {
      ...testcycle,
      statuses,
      statusCounts,
      totalExecutions,
      latestIterationExecutions,
      lastUpdated: latestExecution ? getDateAndTime(latestExecution.updated_at) : "Not Executed",
      lastUpdatedRaw: latestExecution ? new Date(latestExecution.updated_at).getTime() : 0,
      totalIterations: testcycle?.iteration_details?.length,
      totalAssociatedTestCases: allTestCaseIds.size,
      testCasesWithNoExecutions,
    };
  });
}

export const defaultFormData = {
  priority: '',
  status: '',
  module: null,
  owner: '',
  labels: [],
  testsuites: [],
  estimatedTime: '',
  isAutomated: 'No',
  reasonForNotAutomated: '',
  technologyLayer: '',
  objective: '',
  summary: '',
  preCondition: '',
  reviewer: '',
  automatedBy: '',
  automationMethod: null,
  isAutomationNeeded: false,
  automationStatus: null,
  country: [],
  notAutomatedCategory: null,
  notAutomatedSubCategory: null,
};

export const SCREEN = {
  CHOICE:      'choice',
  AI_INPUT:    'ai_input',
  FORM:        'form',
  JIRA_INPUT:  'jira_input',
  JIRA_REVIEW: 'jira_review',
};

export const SAVE_PHASE = {
  IDLE:    'idle',
  SAVING:  'saving',
  LINKING: 'linking',
  SUCCESS: 'success',
  PARTIAL: 'partial',
  ERROR:   'error',
};
 
export const AUTO_CLOSE_MS = 5000;

export const COVERAGE_TAG_COLORS = {
  'Happy Path': { bg: '#D1FAE5', color: '#065F46' },
  'Edge Case': { bg: '#E0E7FF', color: '#3730A3' },
  'Negative': { bg: '#FEE2E2', color: '#991B1B' },
  'Security': { bg: '#FEF3C7', color: '#92400E' },
};